import ListIcon from "@/components/list-icon"
import { User } from "@/redux/user.types"
import { faUser, faUserSlash } from "@fortawesome/free-solid-svg-icons"

interface Props {
  user?: User | null
  placeholder?: string
}

export default function PreventionActionResponsibleButton({ user, placeholder = "Non défini" }: Props) {
  return (
    <div className="flex" title={user?.username}>
      <ListIcon
        fallbackIcon={user ? faUser : faUserSlash}
        image={user?.imageUrl}
        iconColor={user ? undefined : "#eb5a46"}
      />
      <div className="my-auto min-w-0">
        <div className={user ? "truncate" : "red-t truncate"}>{user?.username || user?.email || placeholder}</div>
      </div>
    </div>
  )
}
